<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>
<div class="new-tlr-container">
  <div class="validation-message" *ngIf="showRepumpValidationMessage">
    This is the NEW repump. Repump count: {{repumpCount}}
  </div>
  <div class="validation-message" *ngIf="repumpNotAllowed">
    <b>TLR Repaired:</b> This TLR has been repaired. No repumps are allowed.
  </div>
  <!-- Tag validation message display -->
  <div class="validation-message" *ngIf="showTagValidationMessage">
    This tag number {{tagNumber}} already exists in the TLR system. Are you sure the tag and facility are correct? If
    not, please click 'Start Over' If everything seems correct, you agree that this is a repump by clicking 'Continue'
    to continue.
  </div>

  <div class="validation-message" *ngIf="validMaximoRecord">
    <b>Maximo Connection Successful - No Data Found </b> Connecting to Maximo was successful, but no data was available.
    You may continue to create a TLR record, but Maximo data will not available until a connection is made with Maximo
    at a later time. The TLR nightly sync will pull over all updated Maximo data. Please be sure to enter your Maximo
    data. Please continue.
  </div>
  
  <!-- Show repump count message when applicable -->
  <div class="validation-message" *ngIf="showRepumpDetails">
    This is the NEW repump. Repump count: {{repumpCount}}
  </div>

  <!-- Header bar with radio buttons -->
  <div class="header-bar">
    <div class="header-title">{{ selectedOption === 'Pre-Installation' ? 'NEW TLR' : selectedOption === 'Repump' ?
      'Repump' : selectedOption === 'Edit' ? 'Edit TLR' : '' }}</div>

    <!-- Radio options with handlers to reset fields properly -->
    <div class="radio-group" *ngIf="showRadioButtons">
      <label class="radio-option">
        <input type="radio" name="tlrOption" [(ngModel)]="selectedOption" value="Pre-Installation" (change)="rdNewTLR()"
          checked>
        <span class="radio-label">Create New TLR</span>
      </label>
      <label class="radio-option">
        <input type="radio" name="tlrOption" [(ngModel)]="selectedOption" value="Repump" (change)="rdRepump()">
        <span class="radio-label">Repump TLR</span>
      </label>
    </div>
  </div>

  <!-- Single Tag Number Input row with conditional buttons -->
  <div class="tag-input-row">
    <div class="tag-number-label">Tag Number</div>
    <div class="p-input-wrapper">
      <input pInputText type="text" [(ngModel)]="tagNumber" [readonly]="disableTagInput" (keyup.enter)="validateTag()"
        [placeholder]="!showRepumpDetails ? 'Enter tag number' : ''" numericOnly [maxLength]="5">
      <div class="instruction-text-below b700">Use numbers only, leading zeros if necessary</div>
    </div>

    <!-- Conditional buttons based on state -->
    <p-button *ngIf="showValidateButton" label="Validate Tag" styleClass="validate-btn p-button-sm"
      (onClick)="validateTag()"></p-button>
    <p-button *ngIf="showContinueButton" label="Continue" styleClass="validate-btn p-button-sm"
      (onClick)="continue()"></p-button>
    <p-button *ngIf="showStartOverButton" label="Start Over" styleClass="validate-btn p-button-sm"
      (onClick)="startOver()"></p-button>
    <p-button label="Cancel" styleClass="cancel-btn p-button-sm p-button-secondary" (onClick)="cancel()"></p-button>
  </div>
  <div *ngIf="showDefaultMessage">
    Please be sure to <span class="red"> enter the Maximo Work Order FIRST</span> then enter the TLR tag number here. If
    you need assistance,
    please follow the PowerPoint charts at this link: <a (click)='openFileInNewTab("TLRintoMaximo.pptx")'
      class="link">HERE</a>
  </div>
  <div *ngIf="showMessage" class="smalltext" [innerHTML]="operatorMessage"></div>

  <div *ngIf="editMessage" class="smalltext flex-container red">
    <div>
      <img src="../../../../assets/stop.jpg" alt="Stop Icon" class="stopicon" />
    </div>
    STOP! Please enter the Maximo Work Order with the TLR Tag Number in the TLR Attributes field FIRST. Then enter the
    TLR Tag Number here. Otherwise you will be creating an Orphan TLR and you will be sent an Orphan TLR email every
    night to write a Maximo Work Order.
  </div>
  <div *ngIf="editMessage" class="smalltext b700">
    If you need assistance, please follow the link to the PowerPoint Presentation <a href="#">HERE</a> <br />
    Follow this link to get into Maximo: <a href="#">HERE</a>
  </div>

  <!--Maximo Details-->
  <div *ngIf="showMaximoDetails && tlrData" class="maximo-details">
    <div class="section-header">Maximo</div>
    <div class="maximo-data">
      <table class="details-table">
        <tr>
          <td class="label-cell">TLR Description :</td>
          <td class="value-cell">{{tlrData.mx_tlr_description}}</td>
          <td class="label-cell">Reported By :</td>
          <td class="value-cell">{{tlrData.mx_reportedby}}</td>
        </tr>
        <tr>
          <td class="label-cell">Description :</td>
          <td class="value-cell">{{tlrData.mx_description}}</td>
          <td class="label-cell">Report Date :</td>
          <td class="value-cell">{{tlrData.mx_reportdate | date:'MM/dd/yyyy hh:mm:ss:a'}}</td>
        </tr>
        <tr>
          <td class="label-cell">Work Order Number :</td>
          <td class="value-cell">{{tlrData.mx_wonum}}</td>
          <td class="label-cell">Complete By Date :</td>
          <td class="value-cell">{{tlrData.mx_compbydate | date:'MM/dd/yyyy hh:mm:ss:a'}}</td>
        </tr>
        <tr>
          <td class="label-cell">Work Order Status :</td>
          <td class="value-cell">{{tlrData.mx_wo_status}}</td>
          <td class="label-cell">Need Date :</td>
          <td class="value-cell">{{tlrData.mx_needbydate | date:'MM/dd/yyyy hh:mm:ss:a'}}</td>
        </tr>
        <tr>
          <td class="label-cell">Work Type :</td>
          <td class="value-cell">{{tlrData.mx_worktype}}</td>
          <td class="label-cell">Work Location :</td>
          <td class="value-cell">{{tlrData.mx_worklocation}}</td>
        </tr>
        <tr>
          <td class="label-cell">Work Order Status Date :</td>
          <td class="value-cell">{{tlrData.mx_wo_status_date | date:'MM/dd/yyyy hh:mm:ss:a'}}</td>
          <td class="label-cell">Outage-TA Number :</td>
          <td class="value-cell">{{tlrData.mx_outage}}</td>
        </tr>
        <tr>
          <td class="label-cell">Priority/Criticality :</td>
          <td class="value-cell">{{tlrData.mx_wopriority}}</td>
          <td class="label-cell">Asset Number :</td>
          <td class="value-cell">{{tlrData.mx_assetnum}}</td>
        </tr>
        <tr>
          <td class="label-cell">Planner :</td>
          <td class="value-cell">{{tlrData.mx_planner}}</td>
          <td class="label-cell">Legacy ID :</td>
          <td class="value-cell">{{tlrData.mx_legacyid}}</td>
        </tr>
      </table>
    </div>
  </div>

  <!--Maximo Edit Details-->
  <div *ngIf="showEditDetails && tlrObject" class="maximo-edit-details">
    <div class="tlr-form">
      <table class="tlr-form-table">
        <tr>
          <td class="label-cell">Date Entered Into System :</td>
          <td class="value-cell">{{tlrObject.de_date_entered | date:'MM/dd/yyyy hh:mm:ss:a'}}</td>
        </tr>
        <tr>
          <td class="label-cell">TLR Status :</td>
          <td class="value-cell" [ngClass]="{'red': tlrObject.tlr_status  === 'R', 'green': tlrObject.tlr_status  === 'I', 'blue': tlrObject.tlr_status  === 'P'}">{{tlrObject.tlr_status  === 'I' ? 'Installed' :  tlrObject.tlr_status  === 'R' ? 'Removed' : 'Pre-Installation'}}</td>
        </tr>
        <tr>
          <td class="label-cell">Tag Number :</td>
          <td class="value-cell">{{tlrObject.tag_number}}</td>
        </tr>
        <tr>
          <td class="label-cell">Repair Type :</td>
          <td class="value-cell">
            <div class="radio-group value-cell">
              <label class="radio-option" *ngFor="let repairType of dropdownList?.repairTypes">
                <input type="radio" name="repairType" [value]="repairType" [(ngModel)]="tlrObject.repair_type_name" [checked]="tlrObject.repair_type_name === repairType">
                {{repairType}}
              </label>
            </div>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Plant :</td>
          <td class="value-cell">
            <select class="form-control" [(ngModel)]="tlrObject.plant_name">
              <option>--------------------None Selected------------------</option>
              <option *ngFor="let plant of dropdownList?.plants" [value]="plant.plantName">{{plant.plantMaximo}} -
                {{plant.plantName}}</option>
            </select>
          </td>
        </tr>
        <tr *ngIf="(action === 'update') || (selectedOption?.toLowerCase() === 'repump')">
          <td class="label-cell">Division</td>
          <!-- IGP <td class="value-cell">{{tlrObject.division_name}}</td> -->
            <select class="form-control" [(ngModel)]="tlrObject.division_name">
              <option>--------------------None Selected------------------</option>
              <option *ngFor="let Division of dropdownList?.Division" [value]="Division.Division">{{Division.Maximo}} -
                {{Division.division_name}}</option>
            </select>
        </tr>
        <tr *ngIf="(action === 'update') || (selectedOption?.toLowerCase() === 'repump')">
          <td class="label-cell">Section</td>
          <!--IGP <td class="value-cell">{{tlrObject.section_name}}</td> -->
            <select class="form-control" [(ngModel)]="tlrObject.section_name">
              <option>--------------------None Selected------------------</option>
              <option *ngFor="let Section of dropdownList?.Section" [value]="Section.Section">{{Section.Maximo}} -
                {{Section.section_name}}</option>
            </select>
        </tr>
        <tr>
          <td class="label-cell">Associated Plant - Shutdown :</td>
          <td class="value-cell">
            <select class="form-control" [(ngModel)]="tlrObject.assoc_plant_shutdown">
              <option>--------------------None Selected------------------</option>
              <option *ngFor="let plant of dropdownList?.plants" [value]="plant.plantName">{{plant.plantMaximo}} -
                {{plant.plantName}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Shutdown Description :</td>
          <td class="value-cell">
            <select class="form-control" [(ngModel)]="tlrObject.shutdown_description">
              <option>--------------------None Selected------------------</option>
              <option *ngFor="let shutdown of dropdownList?.shutdown" [value]="shutdown">{{shutdown}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Rule 1173 :</td>
          <td class="value-cell">
            <div class="radio-group">
              <label class="radio-option">
                <input type="radio" name="rule1173" [value]="'Equipment Integrity'" [(ngModel)]="tlrObject.rule_1173">
                Equipment Integrity
              </label>
              <label class="radio-option">
                <input type="radio" name="rule1173" [value]="'Fugitive Emission'" [(ngModel)]="tlrObject.rule_1173">
                Fugitive
                Emission
              </label>
              <label class="radio-option">
                <input type="radio" name="rule1173" [value]="'Unknown'" [(ngModel)]="tlrObject.rule_1173"> Unknown
              </label>
            </div>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Leaking From :</td>
          <td class="value-cell">
            <select class="form-control" [(ngModel)]="tlrObject.leaking_name">
              <option>--------------------None Selected------------------</option>
              <option *ngFor="let leak of dropdownList?.leakings" [value]="leak">{{leak}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Other Leak Type :</td>
          <td class="value-cell">
            <input type="text" class="form-control" [(ngModel)]="tlrObject.leaking_other"
              placeholder="If not found in list above,please specify here">
          </td>
        </tr>
        <tr>
          <td class="label-cell">Operating PSI :</td>
          <td class="value-cell">
            <input type="text" class="form-control" [value]="tlrObject.operating_PSI"
              [(ngModel)]="tlrObject.operating_PSI" placeholder="Enter operating PSI" numericOnly>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Operating Temp :</td>
          <td class="value-cell">
            <input type="text" class="form-control" [value]="tlrObject.operating_temperature"
              [(ngModel)]="tlrObject.operating_temperature" placeholder="Enter operating temperature">
          </td>
        </tr>
        <tr>
          <td class="label-cell">Vapor/Liquid :</td>
          <td class="value-cell">
            <select class="form-control " [(ngModel)]="tlrObject.material_state_name">
              <option *ngFor="let material of dropdownList?.materialStates" [value]="material">{{material}}</option>>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Services :</td>
          <td class="value-cell">
            <div class="checkbox-group">
              <div class="checkbox-option" *ngFor="let service of dropdownList?.services; let i = index">
                <input type="checkbox" [id]="'service_' + i" [value]="service" [(ngModel)]="selectedServices[i]"
                  (change)="updateOperationService()">
                <label class="value-cell" [for]="'service_' + i">{{service}}</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Other Services :</td>
          <td class="value-cell">
            <input type="text" class="form-control" placeholder="If not listed above, please specify"
              [(ngModel)]="tlrObject.service_other">
          </td>
        </tr>
        <tr>
          <td class="label-cell">Permanent Repair Completed :</td>
          <td class="value-cell">
            <input type="checkbox" [checked]="tlrObject.permRepairComplete === '1'"
              (change)="onPermRepairCompleteChange($event)" id="permRepairComplete">
          </td>
        </tr>
        <tr>
          <td class="label-cell">Technical Justification :</td>
          <td class="value-cell">
            <select class="form-control" [(ngModel)]="tlrObject.technicalJustification"
              (change)="onJustificationChange($event)">
              <option>-----------------------None Selected-----------------------</option>
              <option *ngFor="let option of technicalJustificationOptions" [value]="option.value">
                {{option.text}}
              </option>
            </select>
            <div *ngIf="showOtherJustification">
              <!-- Input field for technical justification if "Other" is selected -->
              <input type="text" class="form-control" [(ngModel)]="othertechJustification" />
              <span class="red">Please enter technical justification</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="label-cell">Location / Comments :<br>(included in email)</td>
          <td class="value-cell">
            <textarea class="form-control" rows="3" [(ngModel)]="tlrObject.operator_comments"></textarea>
            <div class="comment-hint">For ease of TLR repair please include the distance and direction to the TLR from
              the closest piece of equipment. For example, "5 feet North of V-410".</div>
          </td>
        </tr>
      </table>
      <div class="button-row">
        <p-button label="Save" styleClass="save-btn" (onClick)="addOrUpdateTLRData()"></p-button>
      </div>
    </div>
  </div>
  <!-- Repump TLR Details Display -->
  <div *ngIf="showRepumpDetails && tlrData">
    <!-- TLR Details Table using PrimeNG p-table -->
    <div class="tlr-details-table-container">
      <p-table [value]="[tlrData]" styleClass="p-datatable-sm" [tableStyle]="{'margin-top': '15px'}">
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td class="label-cell">Date Entered Into System</td>
            <td class="value-cell">{{rowData.de_date_entered | date:'MM/dd/yyyy hh:mm:ss:a'}}</td>
          </tr>
          <tr>
            <td class="label-cell">Operator User ID</td>
            <td class="value-cell">{{rowData.de_cai}}</td>
          </tr>
          <tr>
            <td class="label-cell">TLR Status</td>
            <td class="value-cell status-installed">{{rowData.tlr_status =='I' ? 'Installed' : rowData.tlr_status ==
              'D'
              ? 'Deleted' : 'Pre-Instllation'}}</td>
          </tr>
          <tr>
            <td class="label-cell">Repair Type</td>
            <td class="value-cell">{{rowData.repair_type_name}}</td>
          </tr>
          <tr *ngIf="(action === 'update') || (selectedOption?.toLowerCase() === 'repump')">
            <td class="label-cell">Division</td>
            <td class="value-cell">{{rowData.division_name}}</td>
          </tr>
          <tr *ngIf="(action === 'update') || (selectedOption?.toLowerCase() === 'repump')">
            <td class="label-cell">Section</td>
            <td class="value-cell">{{rowData.section_name}}</td>
          </tr>
          <tr>
            <td class="label-cell">Plant</td>
            <td class="value-cell">{{rowData.plant_name}}</td>
          </tr>
          <tr>
            <td class="label-cell">Shutdown Description</td>
            <td class="value-cell">{{rowData.shutdown_description}}</td>
          </tr>
          <tr>
            <td class="label-cell">Associated Plant - Shutdown</td>
            <td class="value-cell">{{rowData.assoc_plant_shutdown}}</td>
          </tr>
          <tr>
            <td class="label-cell">Rule 1173</td>
            <td class="value-cell">{{rowData.rule_1173}}</td>
          </tr>
          <tr>
            <td class="label-cell">Leaking From</td>
            <td class="value-cell">{{rowData.leaking_name}}</td>
          </tr>
          <tr>
            <td class="label-cell">Other Leak Type specified here</td>
            <td class="value-cell">{{rowData.leaking_other}}</td>
          </tr>
          <tr>
            <td class="label-cell">Operating PSI</td>
            <td class="value-cell">{{rowData.operating_PSI}}</td>
          </tr>
          <tr>
            <td class="label-cell">Operating Temp</td>
            <td class="value-cell">{{rowData.operating_temperature}}</td>
          </tr>
          <tr>
            <td class="label-cell">Vapor/Liquid</td>
            <td class="value-cell">{{rowData.material_state_name}}</td>
          </tr>
          <tr>
            <td class="label-cell">Permanent Repair Completed</td>
            <td class="value-cell">{{rowData.permRepairComplete == 0 ? 'No' : 'Yes'}}</td>
          </tr>
          <tr>
            <td class="label-cell">Technical Justification</td>
            <td class="value-cell">{{getTechnicalJustificationText(rowData.technicalJustification)}}</td>
          </tr>
          <!-- Add Comments row to match table style -->
          <tr>
            <td class="label-cell">Repump Comments</td>
            <td class="value-cell">
              <input pInputText type="text" [(ngModel)]="repumpComments" placeholder="Enter comments"
                class="comments-input">
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- Repump Button - Show in both validation and repump modes -->
    <div class="repump-button-container">
      <p-button label="Repump" styleClass="repump-btn p-button-sm" (onClick)="submitRepump()"></p-button>
    </div>
  </div>

</div>